import { RadioGroup } from '@chakra-ui/react';
import React, { Children, cloneElement, forwardRef, useRef } from 'react';
import { BEControlGroupProps } from './BEControlGroupProps';
import {
  StyledBEControlGroup,
  StyledBEControlGroupBox,
} from './StyledBEControlGroup';

const mergeRefs = (...refs) => {
  const filteredRefs = refs.filter(Boolean);
  if (!filteredRefs.length) return null;
  if (filteredRefs.length === 0) return filteredRefs[0];
  return (inst) => {
    for (const ref of filteredRefs) {
      if (typeof ref === 'function') {
        ref(inst);
      } else if (ref) {
        ref.current = inst;
      }
    }
  };
};

/* eslint-disable react/display-name */
const BEControlGroup = forwardRef<HTMLDivElement, BEControlGroupProps>(
  ({ children, direction = 'horizontal', ...rest }, ref) => {
    const _ref = useRef(null);
    return (
      <RadioGroup>
        <StyledBEControlGroup
          {...rest}
          direction={direction}
          ref={mergeRefs(_ref, ref)}
        >
          {Children.map(children as any, (child: React.ReactElement) => (
            <StyledBEControlGroupBox direction={direction}>
              {cloneElement(child, { ...child.props })}
            </StyledBEControlGroupBox>
          ))}
        </StyledBEControlGroup>
      </RadioGroup>
    );
  }
);

export default BEControlGroup;
